

// init functions
$(function () {
	'use strict';

	$( document ).ready(function() {
		__floatLabels();
	});

	// toggle password
	$(".toggle-password").click(function () {

		$(this).toggleClass("active");
		var input = $($(this).attr("toggle"));
		if (input.attr("type") == "password") {
			input.attr("type", "text");
		} else {
			input.attr("type", "password");
		}
	});
});

function __floatLabels() {
	var thisInput, inputField;

	inputField = $('.input > .form-control')

	inputField.focus(function () {
		thisInput = $(this);
		$("label[for='" + thisInput.attr('id') + "']").addClass("animate-label");
	});

	inputField.blur(function () {
		thisInput = $(this);
		if (thisInput.val() == "") {
			$("label[for='" + thisInput.attr('id') + "']").removeClass("animate-label");
		}
	});

	$('.input').each(function(){
		var val = $(this).find('.form-control').val();
		if(val != ''){
			$(this).find('.control-label-inside').addClass('animate-label')
		}
	});
}
